"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Cancel = _interopRequireDefault(require("@mui/icons-material/Cancel"));
var _StarRounded = _interopRequireDefault(require("@mui/icons-material/StarRounded"));
var _Chip = _interopRequireDefault(require("@mui/material/Chip"));
var _Tooltip = _interopRequireDefault(require("@mui/material/Tooltip"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = props => {
  const {
    children,
    selectProps,
    removeProps,
    data
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip.default, {
    title: children || '',
    enterDelay: 500,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Chip.default, {
      icon: data.key ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_StarRounded.default, {
        fontSize: "small"
      }) : undefined,
      classes: {
        root: selectProps.classes.chip,
        label: selectProps.classes.chipLabel
      },
      tabIndex: -1,
      label: children,
      onDelete: removeProps.onClick,
      deleteIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Cancel.default, {
        fontSize: "small",
        ...removeProps
      })
    })
  });
};
exports.default = _default;